import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';
import { lastValueFrom } from 'rxjs';
import { SessionStorageService } from './core/services/session-storage.service';
import { GlobalLoaderComponent } from './shared/components/global-loader/global-loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, GlobalLoaderComponent],
  template: `
    <app-global-loader></app-global-loader>
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class AppComponent implements OnInit {
  title = 'substantiation assessment tool';

  constructor(
    private calService: CalAngularService,
    private sessionStorage: SessionStorageService
  ) {}

  ngOnInit(): void {
    this.initializeAuth();
  }

  private async initializeAuth(): Promise<void> {
    try {
      const isSignedIn = await lastValueFrom(this.calService.isUserSignedIn());
      if (isSignedIn) {
        console.log('User is already signed in');
        this.cacheCurrentUserInfo();
      } else {
        console.log('Initiating user sign-in');
        await this.signIn();
      }
    } catch (error) {
      console.error('Error during authentication initialization:', error);
    }
  }

  private async signIn(): Promise<boolean> {
    try {
      const user = await lastValueFrom(this.calService.userInitiatedSignIn());
      if (user) {
        console.log('User signed in successfully:', user.email || user.name);
        this.cacheUserInfo(user);
        return true;
      } else {
        console.warn('User sign-in returned empty user object');
        return false;
      }
    } catch (error) {
      console.error('Error during sign-in:', error);
      return false;
    }
  }

  private cacheCurrentUserInfo(): void {
    try {
      const account = this.calService.getAccount();
      if (account) {
        this.cacheUserInfo(account);
      }
    } catch (error) {
      console.error('Error caching current user info:', error);
    }
  }

  private cacheUserInfo(user: any): void {
    try {
      const userInfo = {
        name: user.name || '',
        email: user.email || '',
        objectId: user.localAccountId || '',
        idTokenClaims: user.idTokenClaims || {}
      };
      
      this.sessionStorage.setItem('currentUser', userInfo);
      console.log('User info cached in session storage');
    } catch (error) {
      console.error('Error caching user info:', error);
    }
  }

  logout(): void {
    try {
      this.calService.userInitiatedSignOut();
      this.sessionStorage.clear();
      console.log('User signed out successfully');
    } catch (error) {
      console.error('Error during sign-out:', error);
    }
  }
}
